import { useAuthStore } from "@roman/shared/store/auth.store";
import { cn } from "@roman/shared/utils";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ComingSoonBadge } from "./CommingSoonBadge";
import { NavigationItemId, menuLists, menuListsPredictionMarket } from "./Menu";
import { MyContestBadge } from "./MyContestBadge";
import type { LayoutDisplayType } from "./type";

export const BottomNavigationBar = ({
  active,
  className,
  displayType = "default",
}: {
  active?: NavigationItemId;
  className?: string;
  displayType?: LayoutDisplayType;
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((state) => state.authState === "authenticated");

  const currentPath = useMemo(() => {
    return `${location.pathname}${location.search}`;
  }, [location]);

  const displayMenuList = displayType === "default" ? menuLists : menuListsPredictionMarket;

  return (
    <div
      id="bottom-navigation-bar"
      style={{ boxShadow: "0px -3px 3px 0px rgba(0, 0, 0, 0.10)" }}
      className={cn(
        "z-10 fixed bottom-0 left-1/2 transform -translate-x-1/2 h-[76px] bg-white w-full grid grid-cols-5 items-center gap-x-1 px-3",
        className,
      )}
    >
      {displayMenuList
        .filter((item) => item.id !== NavigationItemId.AboutSamba)
        .map((item) => {
          const isActive = active ? item.id === active : item.link === currentPath;

          return (
            <button
              type="button"
              key={item.bottomName}
              className={cn(
                "relative flex flex-col gap-1 items-center cursor-pointer",
                item.isComingSoon && "opacity-70 cursor-default",
              )}
              onClick={() => {
                if (item.isComingSoon) {
                  return;
                }

                if (isAuthenticated || !item.isRequiredLogin) {
                  navigate(item.link);
                } else {
                  navigate("/login");
                }
              }}
            >
              <div className="relative">
                {item.icon(isActive ? "text-primary" : "text-gray")}

                {item.id === NavigationItemId.MyContest && <MyContestBadge />}

                {item.isComingSoon && <ComingSoonBadge />}
              </div>

              <p className={cn("text-[10px] text-dark-gray font-bold", isActive && "text-primary")}>
                {item.bottomName}
              </p>
            </button>
          );
        })}
    </div>
  );
};
